import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { fmtDateHeure } from "./common";

export const EVENT_LABELS = {
  creation: "Création", modification: "Modification", preattribution: "Pré-attribution", attribution: "Remise au chauffeur",
  appareil: "Matériel (n° de série)",
  annulation_preattribution: "Pré-attribution annulée", reception: "Réception", constatation: "Mise en attente de constatation",
  defauts: "Éléments défectueux modifiés", config_preattribution: "Pré-attribution (config)",
};

/** Historique d'une scan (frise) : attributions, réceptions, matériel… */
export function HistoriqueScan({ scanId }) {
  const [events, setEvents] = useState(null);
  useEffect(() => {
    if (!scanId) return;
    setEvents(null);
    api.get(`/scans/${scanId}/historique`).then(({ data }) => setEvents(data)).catch((e) => toast.error(errMsg(e)));
  }, [scanId]);
  if (!events) return <p className="text-sm text-muted-foreground">Chargement…</p>;
  if (!events.length) return <p className="text-sm text-muted-foreground">Aucun événement.</p>;
  return (
    <ol className="relative border-l border-border ml-2 space-y-4" data-testid="historique-scan">
      {events.map((e, i) => (
        <li key={i} className="pl-4">
          <span className={`absolute -left-1.5 w-3 h-3 rounded-full border-2 border-background ${e.type === "reception" ? "bg-emerald-500" : e.type === "constatation" ? "bg-red-500" : e.type === "attribution" ? "bg-primary" : "bg-muted-foreground"}`} />
          <p className="text-sm font-semibold">{EVENT_LABELS[e.type] || e.type}{e.chauffeur ? ` — ${e.chauffeur}` : ""}{e.tournee ? <span className="font-normal text-muted-foreground"> · tournée {e.tournee}</span> : null}</p>
          <p className="text-xs text-muted-foreground">{fmtDateHeure(e.date)} · par {e.par?.nom || "—"} (matricule {e.par?.matricule || "—"})</p>
          {e.details && <p className="text-xs">{e.details}</p>}
          {e.commentaire && <p className="text-xs">« {e.commentaire} »</p>}
          {e.ajoutes?.length > 0 && <p className="text-xs text-red-600 dark:text-red-400">+ {e.ajoutes.join(" · ")}</p>}
          {e.retires?.length > 0 && <p className="text-xs text-emerald-600 dark:text-emerald-400">− {e.retires.join(" · ")}</p>}
        </li>
      ))}
    </ol>
  );
}
